<script>
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';

export default {
  components: {
    PhxsgButton,
  },

  props: {
    loadMoreText: {
      type: String,
      default: '',
    },

    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['click'],

  computed: {
    getLoadMoreText() {
      return this.loadMoreText.length > 0 ? this.loadMoreText : this.$t('Button.loadMore');
    },
  },

  watch: {
    isLoading: {
      handler(value) {
        if (value) {
          Toolkit.helpers.buttons.addLoadingState(this.$refs.button);
        } else {
          Toolkit.helpers.buttons.removeLoadingState(this.$refs.button);
        }
      },
      immediate: true,
    },
  },
};
</script>

<template>
  <PhxsgButton ref="button" variant="plain" color="secondary" @click="$emit('click')">
    {{ getLoadMoreText }}
  </PhxsgButton>
</template>
